---
title: "General Meeting - September 2, 2025"
date: "2025-09-02"
startTime: "19:00"
endTime: "20:05"
timezone: "US/Pacific"
type: "General Meeting"
status: "Draft"
attendees: 4
summary: "Discussion of Community Nexus organization, Jet Boat Race communications planning, and DMR technology evaluation for race support."
published: true
---

<script lang="ts">
	export const metadata = {
		title: "General Meeting - September 2, 2025",
		date: "2025-09-02",
		startTime: "19:00",
		endTime: "20:05",
		timezone: "US/Pacific",
		type: "General Meeting",
		status: "Draft",
		attendees: 4,
		summary:
			"Discussion of Community Nexus organization, Jet Boat Race communications planning, and DMR technology evaluation for race support.",
		published: true
	};
</script>

# General Meeting Minutes
## {title}

**Meeting Type:** General Membership Meeting  
**Date:** {date}  
**Time:** {startTime} - {endTime}  
**Location:** 2370 N Polk Ext, Moscow, ID 83843, USA  
**Meeting Called to Order:** 7:00 PM by Austin KF7SIW  

### Attendance
**Members Present:** 1  
**Officers Present:** Austin, Nick, Erin  
**Guests:** 0

### Opening

### Community Nexus Organization

#### Meeting Time Structure
- **Decision Made:** Non-DSARC related Community Nexus meetings will start at 6:30 PM, before the regular 7:00 PM DSARC meeting time
- **Purpose:** Accommodate other community organization discussions while keeping DSARC business separate
- **Implementation:** Effective immediately for future meetings

#### Discord Server Setup
- **Decision Made:** Create a new Discord server specifically for Community Nexus
- **Structure:** Separate channels for each subgroup within Community Nexus
- **DSARC Discord:** Will remain unchanged and separate from Community Nexus server
- **Action Item:** Austin to set up the new Community Nexus Discord server

### Event Reports

#### Jet Boat Races - Previous Weekend
**Reported by:** Austin

**Event Summary:**
- Improved organization compared to previous years
- Good radio coverage achieved with Lewiston Hill repeater
- **Coverage Statistics:**
  - Receive coverage: Approximately 90% of the race course
  - Transmit coverage: Approximately 75% of the race course

#### World Jet Boat Championship 2026
**Dates:** May 8-16, 2026  
**Locations:** Payette River, Riggins, Clearwater, Lewiston, and St. Maries  
**Requirement:** Communications support needed for all race locations

### Communications Technology Planning

#### Winter Training Proposal
- **Proposed by:** Austin
- **Objective:** Organize mock race communications exercises during winter months
- **Purpose:** Prepare more club members for supporting the World Championship races in May
- **Status:** Proposal accepted, planning to begin

#### DMR Equipment Evaluation

**Equipment Under Consideration:**
- Redivis brand portable DMR repeaters
- **Cost:** Approximately $500 each
- **Advantages:** Digital capabilities, potential improved coverage in canyon environments

**Acquisition Strategy:**
- Austin to contact Redivis about potential equipment partnership
- Explore possibility of obtaining equipment for free in exchange for reviews or promotional content

**Comparison Analysis:**
- Evaluating existing Motorola equipment versus new DMR repeaters
- **Factors being considered:**
  - Heat tolerance for outdoor operations
  - Power requirements
  - Linking capabilities between sites

#### Field Testing Plans

**DMR Coverage Testing:**
- **Equipment:** Anytone 578 radios in cross-band mode
- **Locations:** Multiple sites along the Snake River
- **Objective:** Create comprehensive propagation maps
- **Method:** Test DMR communications effectiveness in canyon environments

**DPRS Integration:**
- **System:** Digital Position Reporting System
- **Interval:** 30-second reporting intervals
- **Purpose:** Track coverage areas during boat testing
- **Advantage:** Will clearly show locations where signal is lost

**Previous DMR Performance Data:**
- Aaron reported DMR provided 40% greater distance than VHF on simplex mode
- Suggests potential advantages in canyon environments for boat race communications

#### Boat Testing Logistics
- **Commitment:** Austin to find boat captain willing to participate in river testing
- **Timeline:** September or early October 2025
- **Purpose:** Test communications equipment along actual race routes

### Technical Planning

#### Test Matrix Development
- **Requirement:** Prepare comprehensive comparison matrix
- **Comparison:** DMR versus analog radio performance
- **Scope:** Boat race communications specific testing
- **Timeline:** Complete before scheduled boat test

### Upcoming Events and Activities

#### This Week
- **Friday:** Tower project scheduled
- **Preparation:** [Details to be provided]

#### Community Engagement
- **Event:** Palouse Days
- **Date:** September 13th
- **Participation:** Community Nexus will have a table
- **Coordination:** [Details as available]

#### IMTUF Next
- **Timeline:** Following weeks after Palouse Days
- **Status:** Planning in progress

### Action Items
- [ ] **Austin** - Create new Community Nexus Discord server with separate channels for different groups, ensuring DSARC Discord remains separate
- [ ] **Austin** - Develop event page front-end view for event sign-ups
- [ ] **Austin** - Review Palousafest sign-up list and send emails to listed participants
- [ ] **Group** - Prepare test matrix comparing DMR vs analog radio performance for boat race communications before scheduled boat test
- [ ] **Austin** - Schedule boat ride for testing DMR radio coverage on Snake River in September or early October
- [ ] **Austin** - Contact Redivis regarding potential equipment partnership for DMR repeaters
- [ ] **Nick** - Set up Discord events for upcoming meetings and activities
- [ ] **Austin** - Find boat captain willing to participate in river communications testing

### Adjournment
Meeting adjourned at 8:05 PM.

---

*Minutes prepared by: Austin KF7SIW*  
*Minutes status: Draft - Pending approval at next meeting*